
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { name: '首页', path: '/', icon: 'ri-home-line' },
    { name: '智搜', path: '/search', icon: 'ri-search-line' },
    { name: '人才', path: '/talents', icon: 'ri-user-line' },
    { name: '项目', path: '/projects', icon: 'ri-briefcase-line' },
    { name: '客户', path: '/clients', icon: 'ri-building-line' },
    { name: '沟通', path: '/communication', icon: 'ri-chat-3-line' },
    { name: '管理', path: '/management', icon: 'ri-settings-line' },
  ];

  const [activeMenu, setActiveMenu] = useState('');

  const handleMenuClick = (item: typeof navItems[0]) => {
    navigate(item.path);
    setActiveMenu(item.name);
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <i className="ri-building-2-fill text-white text-lg"></i>
              </div>
              <h1 className="text-xl font-bold text-gray-900">人才招聘管理系统</h1>
            </div>
          </div>
          
          <nav className="flex items-center space-x-1">
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => handleMenuClick(item)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  location.pathname === item.path
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                <i className={`${item.icon} text-base`}></i>
                <span>{item.name}</span>
              </button>
            ))}
          </nav>

          <div className="flex items-center space-x-4">
            <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg cursor-pointer">
              <i className="ri-notification-line text-xl"></i>
            </button>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center">
                <i className="ri-user-fill text-gray-600"></i>
              </div>
              <span className="text-sm font-medium text-gray-700">管理员</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
